import { render, staticRenderFns } from "./MatchList.vue?vue&type=template&id=72daa728&"
import script from "./MatchList.vue?vue&type=script&lang=ts&"
export * from "./MatchList.vue?vue&type=script&lang=ts&"
import style0 from "./MatchList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports